import { Box, Card, CardContent, Typography } from '@mui/material';
import { useUser } from '../../userContext';

export default function License() {

    const { userRegistrationDate } = useUser();
    
    const formattedRegDate = (incDate) => {
        const date = new Date(incDate);
        date.setDate(date.getDate() + 45);
        return date.toString();
    }

    const regDt = formattedRegDate(userRegistrationDate);
    
    return (
        <>
            <Typography fontSize=".75rem" sx={{ pt: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                License Expires: {regDt}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                <Card sx={{ mt: '10px', backgroundColor: '#393637', width: '90%' }}>
                    <CardContent>                        
                        <Typography fontSize=".75rem" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }}>
                            You are accessing a Canfield CyberDefense Group (CCG) Information System (IS) that is provided for CheckMate authorized use only.
                        </Typography>
                        <Typography fontSize=".75rem" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', pt: '5px' }}>
                            By using this IS (which includes any software application attached to this IS), you consent to the following conditions:
                        </Typography>
                        <Typography fontSize=".75rem" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', pt: '5px' }}>
                            The CCG routinely intercepts and monitors communications on this IS for purposes including, but not limited to, performance testing (PT), usage monitoring (UM), system health and status (SMS), and personnel misconduct (PM).
                        </Typography>
                        <Typography fontSize=".75rem" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', pt: '5px' }}>
                            At any time, CCG may inspect and seize data related to configuration, usage, and performance stored on this IS.
                        </Typography>
                        <Typography fontSize=".75rem" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', pt: '5px' }}>
                            Communications usage, or data stored on, this IS related to configurations and operations are not private, are subject to routine monitoring, interception, and search, and may be disclosed or used for any authorized purpose.
                        </Typography>
                        <Typography fontSize=".75rem" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', pt: '5px' }}>
                            This IS includes security measures (e.g., authentication and access controls) to protect CCG interests not for your personal benefit or privacy.
                        </Typography>                        
                    </CardContent>
                </Card>
            </Box>
        </>
    )
}